'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _leaveUsMailFormValidation = require('./leaveUsMailFormValidation');

var _leaveUsMailFormValidation2 = _interopRequireDefault(_leaveUsMailFormValidation);

var _leaveUsMailForm = require('redux/modules/leaveUsMailForm');

var leaveUsMailFormActions = _interopRequireWildcard(_leaveUsMailForm);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeaveUsMailForm = (_dec = (0, _reactRedux.connect)(function () {
  return {};
}, function (dispatch) {
  return (0, _redux.bindActionCreators)(leaveUsMailFormActions, dispatch);
}), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'LeaveUsMail',
  fields: ['email'],
  validate: _leaveUsMailFormValidation2.default
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LeaveUsMailForm, _Component);

  function LeaveUsMailForm() {
    (0, _classCallCheck3.default)(this, LeaveUsMailForm);
    return (0, _possibleConstructorReturn3.default)(this, (LeaveUsMailForm.__proto__ || (0, _getPrototypeOf2.default)(LeaveUsMailForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(LeaveUsMailForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          email = _props.fields.email,
          handleSubmit = _props.handleSubmit;

      var styles = require('./LeaveUsMailForm.scss');
      var renderInput = function renderInput(field, label) {
        return _react2.default.createElement(
          'div',
          { className: 'form-group' + (field.error && field.touched ? ' has-error' : '') },
          _react2.default.createElement(
            'label',
            { htmlFor: field.name, className: 'col-xs-12 col-sm-2 col-sm-offset-3' },
            label
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-6 col-sm-offset-3 ' + styles.inputGroup },
            _react2.default.createElement('input', (0, _extends3.default)({ type: 'text', className: 'form-control', id: field.name }, field)),
            field.error && field.touched && _react2.default.createElement(
              'div',
              { className: 'text-danger' },
              field.error
            )
          )
        );
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'form',
          { className: 'form-horizontal leave-us-mail-form', onSubmit: handleSubmit },
          renderInput(email, 'Váš e-mail'),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-sm-2 col-sm-offset-3' },
              _react2.default.createElement(
                'button',
                { className: 'btn btn-success', onClick: handleSubmit },
                _react2.default.createElement('i', { className: 'fa fa-paper-plane' }),
                ' Odeslat'
              )
            )
          )
        )
      );
    }
  }]);
  return LeaveUsMailForm;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired
}, _temp)) || _class) || _class);
exports.default = LeaveUsMailForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LeaveUsMailForm/LeaveUsMailForm.js
// module id = 1099
// module chunks = 0